<template>
  <component :is="layout">
    <router-view :key="route.meta.portal === 'parent' || route.meta.portal === 'student' ? `${route.meta.portal}-shell` : route.path" />
  </component>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router";
import { Repo } from "@/store/admin/repo";
import { Notification } from "@/store/admin/notification";
import { authCookies } from "@/services/cookies";
import { updateAbility } from "@/abilities/ability";

import AuthLayout from "./layouts/auth";
import DefaultLayout from "./layouts/default.vue";
import PlainLayout from "./layouts/plain.vue";

const route = useRoute();

const handleBeforeUnload = () => {
  localStorage.setItem("TASIS:BREADCRUMB", JSON.stringify(Repo.yearBreadCrumb));
};

const layout = computed(() => {
  if (route.meta.layout === "auth") return AuthLayout;
  if (route.meta.layout === "plain") return PlainLayout;
  return DefaultLayout;
});

const syncSessionAndBadge = () => {
  const user = authCookies.getUser();
  if (user && Object.keys(user).length) {
    Repo.user = user;
    updateAbility(authCookies.getPermissions());
  }
  if (authCookies.hasSession() && user?.portal === "dashboard") {
    Notification.startPolling();
  } else {
    Notification.stopPolling();
  }
};

onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  syncSessionAndBadge();
});

watch(
  () => route.meta.layout,
  () => {
    syncSessionAndBadge();
  }
);

watch(
  () => Repo.user?.type,
  () => {
    if (authCookies.hasSession()) {
      Notification.startPolling();
    }
  }
);

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
  Notification.stopPolling();
});
</script>
